import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { IconComponent } from '../icon/icon.component';
import { IconName } from '@app/utils/enums/icon-enum';

@Component({
  selector: 'app-secondary-logo',
  standalone: true,
  imports: [TranslateModule, IconComponent, RouterModule],
  templateUrl: './secondary-logo.component.html',
  styleUrl: './secondary-logo.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SecondaryLogoComponent {
  public readonly IconName = IconName;
  protected readonly homeRoute = '/';
}
